import type { GetUsersQueryVariables } from '@/generated/usermobile-bff/graphql';

export const USER_PICKER_GET_USERS_VARIABLES = {
  isEnabled: true,
  isActivated: true,
} satisfies GetUsersQueryVariables;
